import { getNotifications } from "../services/apiNotifications";
import { useMappedQuery } from "./queryUtils";

export function useNotifications() {
  return useMappedQuery({
    queryKey: ["notifications"],
    queryFn: getNotifications,
    dataKey: "notifications",
  });
}
